// extracted by mini-css-extract-plugin
export default {"widgetContent":"styles_widgetContent__0j5Zd","usersHeight":"styles_usersHeight__k8GSR","selectedItem":"styles_selectedItem__7ScDu"};